/* GetFit voice shopping assistant — Phase 0 (OpenAI Realtime, WebRTC).
 * Loads only when the page URL has ?voice=1, so it stays invisible to shoppers
 * until we switch it on. Connects via an ephemeral key from the VPS, and fires
 * one dummy client tool (say_hello) to prove the loop end to end.
 */
(function () {
  var CFG = window.GF_VOICE || {};
  if (!new URLSearchParams(location.search).has('voice')) return; // dev gate
  if (!CFG.tokenUrl) return;

  var pc = null, dc = null, micStream = null, audioEl = null;
  var sessionId = null, timer = null, seconds = 0;
  var maxSec = 180, idleSec = 25, idleCount = 0; // cost guardrails (server supplies the values)
  var pendingEnd = false; // end the call after the goodbye audio finishes
  var handledCalls = {}; // dedupe tool calls by id
  function bumpIdle() { idleCount = 0; } // call on any speech activity

  // ---- UI ----
  var btn = document.createElement('button');
  btn.className = 'gfv-btn'; btn.type = 'button';
  btn.setAttribute('aria-label', 'Talk to GetFit');
  btn.innerHTML = micSvg();
  var panel = document.createElement('div');
  panel.className = 'gfv-panel';
  panel.innerHTML =
    '<div class="gfv-panel__row"><span class="gfv-dot"></span><span class="gfv-status">Tap the mic to talk</span><span class="gfv-timer"></span></div>' +
    '<div class="gfv-panel__hint">Recorded to improve service.</div>' +
    '<button type="button" class="gfv-end">End</button>';
  var style = document.createElement('style'); style.textContent = css();
  document.body.appendChild(style); document.body.appendChild(panel); document.body.appendChild(btn);
  var statusEl = panel.querySelector('.gfv-status');
  var timerEl = panel.querySelector('.gfv-timer');

  btn.addEventListener('click', function () { pc ? endCall() : startCall(); });
  panel.querySelector('.gfv-end').addEventListener('click', endCall);

  function setState(s) {
    btn.dataset.state = s;
    panel.dataset.open = (s && s !== 'idle') ? '1' : '';
    var map = { connecting: 'Connecting…', connected: 'Listening…', listening: 'Listening…', speaking: 'Speaking…', idle: 'Tap the mic to talk' };
    statusEl.textContent = map[s] || s;
  }
  function startTimer() {
    seconds = 0; idleCount = 0; timerEl.textContent = '0:00';
    timer = setInterval(function () {
      seconds++; idleCount++;
      var m = Math.floor(seconds / 60), s = seconds % 60;
      timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (seconds >= maxSec) { toast('Voice session ended'); endCall(); return; }
      if (idleCount >= idleSec) { toast('Ended — tap the mic to talk again'); endCall(); return; }
    }, 1000);
  }
  function stopTimer() { if (timer) clearInterval(timer); timer = null; timerEl.textContent = ''; }

  // ---- connection ----
  async function startCall() {
    setState('connecting');
    try {
      var tr = await fetch(CFG.tokenUrl);
      var tok = await tr.json().catch(function () { return {}; });
      if (!tr.ok) { // rate/budget caps return a friendly message to show the shopper
        statusEl.textContent = tok.error || 'Could not connect.';
        setTimeout(function () { cleanup(); }, 2600); return;
      }
      if (!tok.clientSecret) throw new Error('no client secret');
      if (tok.maxSessionSec) maxSec = Number(tok.maxSessionSec);
      if (tok.idleSec) idleSec = Number(tok.idleSec);
      sessionId = 'v-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      micStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      pc = new RTCPeerConnection();

      audioEl = document.createElement('audio'); audioEl.autoplay = true;
      pc.ontrack = function (e) { audioEl.srcObject = e.streams[0]; };
      micStream.getTracks().forEach(function (t) { pc.addTrack(t, micStream); });

      dc = pc.createDataChannel('oai-events');
      dc.onopen = function () { setState('connected'); startTimer(); logEvent('session_start'); };
      dc.onmessage = onEvent;
      pc.ondatachannel = function (e) { e.channel.onmessage = onEvent; }; // safety: also read a server-created channel

      var offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      var sdpRes = await fetch('https://api.openai.com/v1/realtime/calls', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + tok.clientSecret, 'Content-Type': 'application/sdp' },
        body: offer.sdp,
      });
      if (!sdpRes.ok) throw new Error('sdp ' + sdpRes.status);
      var answer = await sdpRes.text();
      await pc.setRemoteDescription({ type: 'answer', sdp: answer });
    } catch (e) {
      console.error('[voice] startCall failed', e);
      statusEl.textContent = (e && e.name === 'NotAllowedError') ? 'Microphone blocked.' : 'Could not connect.';
      cleanup();
    }
  }

  function onEvent(msg) {
    var data = msg.data;
    if (typeof data !== 'string') { if (data && data.text) { data.text().then(function (t) { onEvent({ data: t }); }); } return; }
    var ev; try { ev = JSON.parse(data); } catch (e) { return; }
    switch (ev.type) {
      case 'input_audio_buffer.speech_started': bumpIdle(); setState('listening'); break;
      case 'response.created':
      case 'response.output_audio.delta':
      case 'response.audio.delta': bumpIdle(); setState('speaking'); break;
      case 'response.done': setState('connected'); break;
      case 'output_audio_buffer.stopped': if (pendingEnd) setTimeout(function () { if (pendingEnd) endCall(); }, 250); break;
      case 'response.function_call_arguments.done':
        runTool(ev.name, ev.call_id, ev.arguments); break;
      case 'response.output_item.done':
        if (ev.item && ev.item.type === 'function_call') runTool(ev.item.name, ev.item.call_id, ev.item.arguments); break;
      case 'error': console.warn('[voice] server error', ev.error || ev); break;
    }
  }

  // ---- client tools (Phase 1: search + cart) ----
  var lastResults = []; // what "number 2" refers to

  var TOOLS = {
    search_products: async function (args) {
      args = args || {};
      var r = await fetch(CFG.tokenUrl.replace(/\/token$/, '/search'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(args),
      });
      if (!r.ok) { logEvent('tool_error', 'search_products', args, 'http ' + r.status); return { error: 'Search failed.' }; }
      var d = await r.json();
      lastResults = (d.products || []).slice(0, 12);
      renderResults(lastResults);
      logEvent('tool_call', 'search_products', args, lastResults.length + ' results');
      return { count: lastResults.length, results: lastResults.map(function (p, i) { return { n: i + 1, title: p.title, price: p.price, sizes: p.sizes }; }) };
    },

    open_product: async function (args) {
      args = args || {};
      var n = parseInt(Array.isArray(args.item) ? args.item[0] : args.item, 10);
      var p = lastResults[n - 1];
      if (!p) { logEvent('tool_error', 'open_product', args, 'no such item'); return { error: 'item ' + n + ' does not exist; there are ' + lastResults.length + ' results' }; }
      openQuickView(p, args.size, args.color);
      logEvent('tool_call', 'open_product', args, p.title);
      return { title: p.title, price: p.price, sizes: p.sizes, colors: colorsOf(p) };
    },

    add_to_cart: async function (args) {
      args = args || {};
      var nums = Array.isArray(args.item) ? args.item : [args.item];
      var qty = Math.max(1, parseInt(args.qty, 10) || 1);
      var items = [], errors = [];
      for (var k = 0; k < nums.length; k++) {
        var n = parseInt(nums[k], 10);
        var p = lastResults[n - 1];
        if (!p) { errors.push('item ' + n + ' does not exist; there are ' + lastResults.length + ' results'); continue; }
        var v = pickVariant(p, args.size, args.color);
        if (!v) { errors.push('for ' + p.title + ' please choose a size: ' + (p.sizes.join(', ') || 'see options')); continue; }
        items.push({ id: v.id, quantity: qty });
      }
      if (!items.length) { logEvent('tool_error', 'add_to_cart', args, errors.join(' | ')); return { error: errors.join(' | ') }; }
      try {
        var cart = await pushToCart(items);
        logEvent('tool_call', 'add_to_cart', args, 'items=' + cart.item_count);
        return { added: items.length, cart_count: cart.item_count, subtotal: Math.round(cart.total_price / 100), note: errors.join(' | ') || undefined };
      } catch (e) { logEvent('tool_error', 'add_to_cart', args, String(e)); return { error: 'Could not add to cart.' }; }
    },

    get_cart: async function () {
      var cart = await (await fetch('/cart.js')).json();
      openCart();
      logEvent('tool_call', 'get_cart', {}, 'items=' + cart.item_count);
      return { cart_count: cart.item_count, subtotal: Math.round(cart.total_price / 100), items: (cart.items || []).map(function (it) { return { title: it.product_title, variant: it.variant_title, qty: it.quantity }; }) };
    },

    // The agent calls this after a goodbye; we hang up once that audio finishes.
    end_call: async function () {
      pendingEnd = true;
      logEvent('tool_call', 'end_call', {}, 'goodbye');
      setTimeout(function () { if (pendingEnd) endCall(); }, 6000); // safety net
      return { ok: true };
    },
  };

  // --- variant resolver: match size/colour keywords to a variant, order/name-agnostic ---
  var SIZE_MAP = { 'extra extra large': '2xl', 'double xl': '2xl', xxl: '2xl', 'extra large': 'xl', large: 'l', medium: 'm', small: 's', 'extra small': 'xs' };
  function normSize(s) { s = String(s || '').toLowerCase().trim(); return SIZE_MAP[s] || s; }
  function sizeLike(v) { return /^(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|5xl|\d{1,3})$/i.test(String(v).replace(/\s/g, '')); }
  function pickVariant(p, size, color) {
    var sz = size ? normSize(size) : null;
    var col = color ? String(color).toLowerCase().trim() : null;
    var hasSize = ((p.variants[0] && p.variants[0].options) || []).some(function (o) { return /size/i.test(o.name) || sizeLike(o.value); });
    if (!sz && hasSize) return null; // need a size → let the agent ask
    var cands = (p.variants || []).filter(function (v) {
      if (!v.available) return false;
      var vals = v.options.map(function (o) { return String(o.value).toLowerCase(); });
      if (sz && vals.indexOf(sz) < 0 && v.options.map(function (o) { return normSize(o.value); }).indexOf(sz) < 0) return false;
      if (col && !vals.some(function (x) { return x.indexOf(col) >= 0; })) return false;
      return true;
    });
    return cands[0] || null;
  }
  function isColorOpt(name) { return /colou?r/i.test(name); }
  function colorsOf(p) {
    var seen = {}, out = [];
    (p.variants || []).forEach(function (v) {
      v.options.forEach(function (o) { if (isColorOpt(o.name) && !seen[o.value]) { seen[o.value] = 1; out.push(o.value); } });
    });
    return out;
  }
  function imageForColor(p, color) {
    if (!color) return null;
    var c = String(color).toLowerCase();
    var hit = (p.variants || []).find(function (v) {
      return v.image && v.options.some(function (o) { return isColorOpt(o.name) && String(o.value).toLowerCase().indexOf(c) >= 0; });
    });
    return hit ? hit.image : null;
  }

  // --- shared cart add (used by the add_to_cart tool and the quick-view button) ---
  // After adding, pull fresh cart-drawer HTML from Shopify's Section Rendering
  // API and swap the drawer's inner DOM, so it opens showing the new item with
  // no page refresh. Deterministic — doesn't rely on the theme's own JS methods.
  async function pushToCart(items) {
    var body = { items: items, attributes: { _voice_session: sessionId } };
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    var cart = await (await fetch('/cart.js')).json();
    updateCartCount(cart);
    await renderDrawer(cart);
    openCart();
    return cart;
  }

  // Re-render the live cart drawer from freshly-rendered section HTML, so it
  // opens showing the new item. (The icon count is handled by updateCartCount.)
  async function renderDrawer(cart) {
    try {
      var r = await fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      var data = await r.json();
      if (!data['cart-drawer']) return;
      var fresh = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var freshInner = fresh.querySelector('#CartDrawer');
      var curInner = document.getElementById('CartDrawer');
      if (freshInner && curInner) {
        curInner.innerHTML = freshInner.innerHTML;
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.toggle('is-empty', (cart.item_count || 0) === 0);
        // The X buttons use inline onclick, but the overlay's close listener is
        // bound in JS and lost on innerHTML swap — rebind it.
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay && drawerEl && typeof drawerEl.close === 'function') {
          overlay.addEventListener('click', function () { try { drawerEl.close(); } catch (e) {} });
        }
      }
    } catch (e) {}
  }

  // --- results overlay ---
  function money(n) { return '₦' + Number(n).toLocaleString('en-US'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderResults(list) {
    var wrap = document.getElementById('gfv-results');
    if (!wrap) { wrap = document.createElement('div'); wrap.id = 'gfv-results'; wrap.className = 'gfv-results'; document.body.appendChild(wrap); }
    if (!list.length) {
      wrap.innerHTML = '<div class="gfv-results__hd">No matches — try different words.<button class="gfv-results__x" aria-label="Close">×</button></div>';
    } else {
      wrap.innerHTML = '<div class="gfv-results__hd">' + list.length + ' results<button class="gfv-results__x" aria-label="Close">×</button></div>' +
        '<div class="gfv-results__grid">' + list.map(function (p, i) {
          return '<div class="gfv-card" data-i="' + i + '" role="button" tabindex="0">' +
            '<span class="gfv-card__n">' + (i + 1) + '</span>' +
            (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="gfv-card__noimg"></span>') +
            '<span class="gfv-card__t">' + esc(p.title) + '</span>' +
            '<span class="gfv-card__p">' + money(p.price) + '</span>' +
            '<a class="gfv-card__ext" href="' + p.url + '" target="_blank" rel="noopener" aria-label="Open full page">↗</a></div>';
        }).join('') + '</div>';
    }
    wrap.classList.add('open');
    wrap.querySelector('.gfv-results__x').onclick = function () { wrap.classList.remove('open'); };
    // Tapping a card opens the in-page quick-view (not a page nav — that would drop the call).
    wrap.querySelectorAll('.gfv-card').forEach(function (card) {
      card.onclick = function (e) {
        if (e.target.closest('.gfv-card__ext')) return; // let the full-page link through
        var p = lastResults[parseInt(card.getAttribute('data-i'), 10)];
        if (p) openQuickView(p);
      };
    });
    wrap.scrollTop = 0;
  }

  // --- in-page quick-view (keeps the voice call alive; no page navigation) ---
  var qv = { p: null, size: null, color: null };
  function openQuickView(p, preSize, preColor) {
    qv = { p: p, size: preSize ? normSize(preSize) : null, color: preColor || null };
    var el = document.getElementById('gfv-qv');
    if (!el) { el = document.createElement('div'); el.id = 'gfv-qv'; el.className = 'gfv-qv'; document.body.appendChild(el); }
    var cols = colorsOf(p);
    var hasSizes = (p.sizes || []).length > 0;
    var gallery = []; var seen = {};
    [imageForColor(p, qv.color), p.image].concat(p.images || []).forEach(function (u) { if (u && !seen[u]) { seen[u] = 1; gallery.push(u); } });
    var main = gallery[0] || '';
    el.innerHTML =
      '<div class="gfv-qv__hd">' + esc(p.title) + '<button class="gfv-qv__x" aria-label="Close">×</button></div>' +
      '<div class="gfv-qv__body">' +
      (main ? '<img class="gfv-qv__main" src="' + main + '" alt="">' : '') +
      (gallery.length > 1 ? '<div class="gfv-qv__thumbs">' + gallery.map(function (u, i) { return '<img src="' + u + '" data-u="' + u + '" class="' + (i === 0 ? 'sel' : '') + '" alt="">'; }).join('') + '</div>' : '') +
      '<div class="gfv-qv__price">' + money(p.price) + '</div>' +
      (cols.length ? '<div class="gfv-qv__lbl">Colour</div><div class="gfv-chips" data-k="color">' + cols.map(function (c) { return '<button class="gfv-chip' + (qv.color && String(c).toLowerCase().indexOf(String(qv.color).toLowerCase()) >= 0 ? ' sel' : '') + '" data-v="' + esc(c) + '">' + esc(c) + '</button>'; }).join('') + '</div>' : '') +
      (hasSizes ? '<div class="gfv-qv__lbl">Size</div><div class="gfv-chips" data-k="size">' + p.sizes.map(function (s) { return '<button class="gfv-chip' + (qv.size && normSize(s) === qv.size ? ' sel' : '') + '" data-v="' + esc(s) + '">' + esc(s) + '</button>'; }).join('') + '</div>' : '') +
      '<button class="gfv-qv__add" type="button">Add to cart</button>' +
      '<a class="gfv-qv__full" href="' + p.url + '" target="_blank" rel="noopener">Open full product page ↗</a>' +
      '</div>';

    function syncAdd() {
      var ok = (!hasSizes || qv.size) && (!cols.length || qv.color);
      el.querySelector('.gfv-qv__add').disabled = !ok;
    }
    el.querySelector('.gfv-qv__x').onclick = function () { el.classList.remove('open'); };
    el.querySelectorAll('.gfv-qv__thumbs img').forEach(function (im) {
      im.onclick = function () {
        el.querySelector('.gfv-qv__main').src = im.getAttribute('data-u');
        el.querySelectorAll('.gfv-qv__thumbs img').forEach(function (x) { x.classList.remove('sel'); });
        im.classList.add('sel');
      };
    });
    el.querySelectorAll('.gfv-chips').forEach(function (group) {
      var k = group.getAttribute('data-k');
      group.querySelectorAll('.gfv-chip').forEach(function (chip) {
        chip.onclick = function () {
          group.querySelectorAll('.gfv-chip').forEach(function (x) { x.classList.remove('sel'); });
          chip.classList.add('sel');
          var val = chip.getAttribute('data-v');
          if (k === 'size') { qv.size = normSize(val); }
          else { qv.color = val; var img = imageForColor(p, val); if (img) el.querySelector('.gfv-qv__main').src = img; }
          syncAdd();
        };
      });
    });
    el.querySelector('.gfv-qv__add').onclick = async function () {
      var v = pickVariant(p, qv.size, qv.color);
      if (!v) { toast('Please pick a size' + (cols.length ? ' and colour' : '')); return; }
      this.disabled = true; this.textContent = 'Adding…';
      try {
        var cart = await pushToCart([{ id: v.id, quantity: 1 }]);
        logEvent('tool_call', 'add_to_cart', { item: p.title, size: qv.size, color: qv.color, via: 'quickview' }, 'items=' + cart.item_count);
        el.classList.remove('open');
      } catch (e) { toast('Could not add to cart'); this.disabled = false; this.textContent = 'Add to cart'; }
    };
    syncAdd();
    requestAnimationFrame(function () { el.classList.add('open'); el.scrollTop = 0; });
  }

  // --- cart UI helpers ---
  function updateCartCount(cart) {
    try {
      document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble .cart-count-bubble, [data-cart-count]').forEach(function (el) {
        (el.querySelector('span') || el).textContent = cart.item_count;
      });
      // If the cart icon was in its empty state, swap to the bubble icon so the count shows.
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && cart.item_count > 0 && !bubble.querySelector('.cart-count-bubble')) {
        var b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
        bubble.appendChild(b);
      }
    } catch (e) {}
  }
  function openCart() {
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
  }
  function toast(m) {
    var t = document.createElement('div'); t.className = 'gfv-toast'; t.textContent = m;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('show'); }, 10);
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 2200);
  }

  async function runTool(name, callId, argsStr) {
    if (!callId || handledCalls[callId]) return; handledCalls[callId] = 1;
    var args = {}; try { args = argsStr ? JSON.parse(argsStr) : {}; } catch (e) {}
    var out;
    try {
      var fn = TOOLS[name];
      out = fn ? await fn(args) : { error: 'unknown tool: ' + name };
    } catch (e) {
      out = { error: String(e && e.message || e) };
      logEvent('tool_error', name, args, out.error);
    }
    send({ type: 'conversation.item.create', item: { type: 'function_call_output', call_id: callId, output: JSON.stringify(out) } });
    send({ type: 'response.create' });
  }

  function send(obj) { if (dc && dc.readyState === 'open') dc.send(JSON.stringify(obj)); }

  function endCall() { if (pc) { try { pc.close(); } catch (e) {} } cleanup(); logEvent('session_end'); }
  function cleanup() {
    if (micStream) { micStream.getTracks().forEach(function (t) { t.stop(); }); micStream = null; }
    if (audioEl) { try { audioEl.srcObject = null; } catch (e) {} audioEl = null; }
    pc = null; dc = null; handledCalls = {}; pendingEnd = false; stopTimer(); setState('idle');
  }

  function logEvent(type, tool, params, result) {
    try {
      fetch(CFG.tokenUrl.replace(/\/token$/, '/log'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: sessionId, type: type, tool: tool || null, params: params || null, result: result || null, template: CFG.template }),
      });
    } catch (e) {}
  }

  function micSvg() { return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>'; }

  function css() {
    return '.gfv-btn{position:fixed;right:20px;bottom:150px;z-index:9998;width:56px;height:56px;border-radius:50%;border:none;background:#2d1b69;color:#fff;box-shadow:0 6px 20px rgba(0,0,0,.25);cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .15s}' +
      '.gfv-btn:hover{transform:scale(1.05)}' +
      '.gfv-btn[data-state="connected"],.gfv-btn[data-state="listening"]{background:#128c4b;animation:gfvPulse 1.4s infinite}' +
      '.gfv-btn[data-state="speaking"]{background:#b76e52}' +
      '.gfv-btn[data-state="connecting"]{background:#7a4a3a}' +
      '@keyframes gfvPulse{0%{box-shadow:0 0 0 0 rgba(18,140,75,.5)}70%{box-shadow:0 0 0 14px rgba(18,140,75,0)}100%{box-shadow:0 0 0 0 rgba(18,140,75,0)}}' +
      '.gfv-panel{position:fixed;right:20px;bottom:216px;z-index:9998;width:240px;background:#fff;border:1px solid #eee;border-radius:14px;box-shadow:0 10px 30px rgba(0,0,0,.18);padding:14px 16px;font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif;display:none}' +
      '.gfv-panel[data-open="1"]{display:block}' +
      '.gfv-panel__row{display:flex;align-items:center;gap:8px;font-size:14px;color:#1a1a1a;font-weight:600}' +
      '.gfv-dot{width:9px;height:9px;border-radius:50%;background:#128c4b}' +
      '.gfv-timer{margin-left:auto;color:#888;font-weight:500;font-size:13px}' +
      '.gfv-panel__hint{font-size:11px;color:#999;margin:6px 0 10px}' +
      '.gfv-end{width:100%;padding:9px;border:none;border-radius:8px;background:#f0e9e5;color:#7a4a3a;font-weight:600;cursor:pointer}' +
      '.gfv-results{position:fixed;left:0;right:0;bottom:0;z-index:9999;max-height:62vh;overflow:auto;background:#fff;border-top:1px solid #e5e5e5;box-shadow:0 -8px 30px rgba(0,0,0,.18);transform:translateY(100%);transition:transform .25s;font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif}' +
      '.gfv-results.open{transform:translateY(0)}' +
      '.gfv-results__hd{position:sticky;top:0;background:#fff;padding:12px 16px;font-weight:700;color:#2d1b69;border-bottom:1px solid #eee;display:flex;align-items:center}' +
      '.gfv-results__x{margin-left:auto;background:none;border:none;font-size:22px;line-height:1;cursor:pointer;color:#888}' +
      '.gfv-results__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px;padding:14px 16px}' +
      '.gfv-card{position:relative;display:flex;flex-direction:column;text-decoration:none;color:#1a1a1a;border:1px solid #eee;border-radius:10px;overflow:hidden;background:#fff}' +
      '.gfv-card img,.gfv-card__noimg{width:100%;aspect-ratio:3/4;object-fit:cover;background:#f3f3f3;display:block}' +
      '.gfv-card__n{position:absolute;top:6px;left:6px;width:24px;height:24px;border-radius:50%;background:#2d1b69;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;z-index:1}' +
      '.gfv-card__t{font-size:13px;line-height:1.3;padding:8px 8px 2px}' +
      '.gfv-card__p{font-size:13px;font-weight:700;color:#7a4a3a;padding:0 8px 8px;margin-top:auto}' +
      '.gfv-card{cursor:pointer}' +
      '.gfv-card__ext{position:absolute;top:6px;right:6px;width:24px;height:24px;border-radius:50%;background:rgba(255,255,255,.9);color:#2d1b69;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;text-decoration:none;z-index:1}' +
      '.gfv-qv{position:fixed;left:0;right:0;bottom:0;z-index:10001;background:#fff;border-top:1px solid #e5e5e5;box-shadow:0 -10px 40px rgba(0,0,0,.22);transform:translateY(100%);transition:transform .25s;font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif;max-height:90vh;overflow:auto}' +
      '.gfv-qv.open{transform:translateY(0)}' +
      '@media(min-width:620px){.gfv-qv{left:50%;right:auto;bottom:20px;width:460px;border:1px solid #e5e5e5;border-radius:16px;transform:translate(-50%,130%)}.gfv-qv.open{transform:translate(-50%,0)}}' +
      '.gfv-qv__hd{position:sticky;top:0;background:#fff;display:flex;align-items:center;gap:8px;padding:14px 16px;border-bottom:1px solid #eee;font-weight:700;color:#2d1b69;font-size:15px}' +
      '.gfv-qv__x{margin-left:auto;background:none;border:none;font-size:22px;line-height:1;cursor:pointer;color:#888;flex:0 0 auto}' +
      '.gfv-qv__body{padding:16px}' +
      '.gfv-qv__main{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:12px;background:#f3f3f3;display:block}' +
      '.gfv-qv__thumbs{display:flex;gap:8px;margin-top:10px;overflow-x:auto}' +
      '.gfv-qv__thumbs img{width:54px;height:54px;object-fit:cover;border-radius:8px;border:2px solid transparent;cursor:pointer;flex:0 0 auto}' +
      '.gfv-qv__thumbs img.sel{border-color:#2d1b69}' +
      '.gfv-qv__price{font-size:21px;font-weight:800;color:#7a4a3a;margin:14px 0 2px}' +
      '.gfv-qv__lbl{font-size:11px;font-weight:700;color:#777;margin:16px 0 8px;text-transform:uppercase;letter-spacing:.04em}' +
      '.gfv-chips{display:flex;flex-wrap:wrap;gap:8px}' +
      '.gfv-chip{padding:9px 15px;border:1.5px solid #ddd;border-radius:999px;background:#fff;font-size:14px;cursor:pointer;color:#1a1a1a}' +
      '.gfv-chip.sel{border-color:#2d1b69;background:#2d1b69;color:#fff}' +
      '.gfv-qv__add{width:100%;margin-top:18px;padding:14px;border:none;border-radius:10px;background:#128c4b;color:#fff;font-weight:700;font-size:15px;cursor:pointer}' +
      '.gfv-qv__add:disabled{background:#c2c2c2;cursor:not-allowed}' +
      '.gfv-qv__full{display:block;text-align:center;margin-top:12px;font-size:13px;color:#2d1b69}' +
      '.gfv-toast{position:fixed;bottom:220px;right:20px;z-index:10002;background:#1a1a1a;color:#fff;padding:10px 16px;border-radius:8px;font-size:14px;font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif;opacity:0;transform:translateY(8px);transition:all .25s}' +
      '.gfv-toast.show{opacity:1;transform:translateY(0)}';
  }
})();
